/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SalesContactOtherCompany } from "./SalesContactOtherCompany";
import {
  SalesContactOtherCompanyFromJSON,
  SalesContactOtherCompanyFromJSONTyped,
  SalesContactOtherCompanyToJSON,
  SalesContactOtherCompanyToJSONTyped,
} from "./SalesContactOtherCompany";

/**
 *
 * @export
 * @interface SalesContactNameElsewhere
 */
export interface SalesContactNameElsewhere {
  /**
   *
   * @type {string}
   * @memberof SalesContactNameElsewhere
   */
  salesContactId: string;
  /**
   *
   * @type {string}
   * @memberof SalesContactNameElsewhere
   */
  contactName: string;
  /**
   *
   * @type {Array<SalesContactOtherCompany>}
   * @memberof SalesContactNameElsewhere
   */
  otherCompanies: Array<SalesContactOtherCompany>;
}

/**
 * Check if a given object implements the SalesContactNameElsewhere interface.
 */
export function instanceOfSalesContactNameElsewhere(
  value: object,
): value is SalesContactNameElsewhere {
  if (!("salesContactId" in value) || value["salesContactId"] === undefined)
    return false;
  if (!("contactName" in value) || value["contactName"] === undefined)
    return false;
  if (!("otherCompanies" in value) || value["otherCompanies"] === undefined)
    return false;
  return true;
}

export function SalesContactNameElsewhereFromJSON(
  json: any,
): SalesContactNameElsewhere {
  return SalesContactNameElsewhereFromJSONTyped(json, false);
}

export function SalesContactNameElsewhereFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesContactNameElsewhere {
  if (json == null) {
    return json;
  }
  return {
    salesContactId: json["salesContactId"],
    contactName: json["contactName"],
    otherCompanies: (json["otherCompanies"] as Array<any>).map(
      SalesContactOtherCompanyFromJSON,
    ),
  };
}

export function SalesContactNameElsewhereToJSON(
  json: any,
): SalesContactNameElsewhere {
  return SalesContactNameElsewhereToJSONTyped(json, false);
}

export function SalesContactNameElsewhereToJSONTyped(
  value?: SalesContactNameElsewhere | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    salesContactId: value["salesContactId"],
    contactName: value["contactName"],
    otherCompanies: (value["otherCompanies"] as Array<any>).map(
      SalesContactOtherCompanyToJSON,
    ),
  };
}
